module.exports = __webpack_public_path__ + "static/media/home-wheel-loaders.c6e34078.jpg";